import { ratingListLabel } from 'keys/rating';
import { rating1, rating2, rating3, rating4, rating5, dark } from 'styles/theme';
import { formatDateIL, formatSchoolYear } from 'utils/formatter'; // נתיב ההתייחסות לקובץ הכלים

export const getChartOptions = (semesters, percent) => {
    return {
        layout: {
            padding: 20,
        },
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: false,
            },
            tooltip: {
                titleAlign: "center",
                bodyAlign: "center",
                displayColors: true,
                filter: function (tooltipItem) {
                    return tooltipItem.datasetIndex === 0;
                },
                callbacks: {
                    title: function (context) {
                        const item = context[0].raw.originalData;
                        return item.assessment_name;
                    },
                    label: function (context) {
                        const item = context.raw.originalData;
                        const formattedDate = formatDateIL(item.date);

                        return [
                            `תאריך: ${formattedDate}`,
                            `שכבה: ${item.grade}`,
                            `${percent ? "דיוק" : "קצב"}: ${item.score}${percent ? '%' : ' מילים לדקה'}`,
                            `דירוג: ${ratingListLabel[item.rating_index - 1]}`
                        ];
                    },
                    labelColor: function (context) {
                        const item = context.raw.originalData;
                        const colors = [rating1, rating2, rating3, rating4, rating5];
                        const currentColor = colors[item.rating_index - 1] || dark;
                        
                        return {
                            borderColor: currentColor,
                            backgroundColor: currentColor,
                            borderWidth: 2,
                        };
                    }
                }
            }
        },
        scales: {
            x: {
                type: "time",
                time: {
                    unit: 'day',
                },
                afterBuildTicks: (scale) => {
                    if (semesters && semesters.length > 0) {
                        const ticks = semesters.map(sem => ({
                            value: new Date(sem.startDate).getTime()
                        }));

                        const lastSemester = semesters[semesters.length - 1];
                        if (lastSemester && lastSemester.endDate) {
                            ticks.push({ value: new Date(lastSemester.endDate).getTime() });
                        }
                        scale.ticks = ticks;
                    }
                },
                ticks: {
                    callback: function (value) {
                        const dateObj = new Date(value);

                        const matchedSemester = semesters?.find(sem =>
                            new Date(sem.startDate).getTime() === dateObj.getTime()
                        );

                        const lastSemester = semesters && semesters.length > 0 ? semesters[semesters.length - 1] : null;
                        const isEndDate = lastSemester &&
                            lastSemester.endDate &&
                            new Date(lastSemester.endDate).getTime() === dateObj.getTime();

                        const dateStr = formatDateIL(dateObj);

                        if (matchedSemester) {
                            const formattedYear = formatSchoolYear(matchedSemester.schoolYear);
                            return [
                                dateStr,
                                `${matchedSemester.name} ${formattedYear}`
                            ];
                        } else if (isEndDate) {
                            const formattedYear = formatSchoolYear(lastSemester.schoolYear);
                            return [
                                dateStr,
                                `סוף שנה"ל ${formattedYear}`
                            ];
                        }

                        return '';
                    }
                }
            },
            y: {
                beginAtZero: true
            }
        }
    };
};